<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <div class="transactions-searches">
        <v-form
          @submit.prevent="filtersSubmission()"
          class="d-flex align-center mb-3 flex-column flex-sm-row justify-sm-space-between"
        >
          <div class="d-flex justify-between flex-wrap">
            <v-autocomplete
              v-model="filtersObj.userId"
              :items="usernamesList.allItems"
              item-value="id"
              item-text="username"
              prepend-inner-icon="mdi-magnify"
              :label="
                $t('panel.transactionPage.withdrawal.searchBoxesForm.userName')
              "
              class="theme-custom-input input-search user-name"
              outlined
              hide-details
              clearable
              dense
              :loading="usernamesList.autocompleteListLoading"
              @focus="
                inputSearchCheck($event, service, 'usernamesList', 'username')
              "
              @keyup="inputSearch($event, service, 'usernamesList', 'username')"
              @paste="inputSearch($event, service, 'usernamesList', 'username')"
              @click:clear="
                inputSearch($event, service, 'usernamesList', 'username')
              "
            >
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectUsernameList"
                  class="ms-4"
                  v-if="
                    !usernamesList.moreItemsLoading &&
                      usernamesList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="usernamesList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>

            <v-text-field
              v-model="filtersObj.transactionId"
              prepend-inner-icon="mdi-magnify"
              :label="
                $t(
                  'panel.transactionPage.withdrawal.searchBoxesForm.transactionId'
                )
              "
              class="theme-custom-input input-search transaction-id"
              outlined
              hide-details
              dense
            />

            <v-dialog ref="dateDialog" v-model="dateDialog" width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  prepend-inner-icon="mdi-calendar"
                  :value="dateRangeText"
                  clearable
                  readonly
                  :label="
                    $t(
                      'panel.transactionPage.withdrawal.searchBoxesForm.dateTime'
                    )
                  "
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="date = []"
                  class="theme-custom-input input-search date"
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </template>
              <v-date-picker v-model="date" range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateDialog = false">
                  {{
                    $t(
                      "panel.transactionPage.withdrawal.searchBoxesForm.dateTimeFormCancel"
                    )
                  }}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dateDialog.save(date)"
                >
                  {{
                    $t(
                      "panel.transactionPage.withdrawal.searchBoxesForm.dateTimeFormOk"
                    )
                  }}
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              prepend-inner-icon="mdi-magnify"
              class="theme-custom-input input-search select-search status"
              v-model="filtersObj.transactionStatuses"
              :items="statusItems"
              outlined
              :label="
                $t('panel.transactionPage.withdrawal.searchBoxesForm.status')
              "
              clearable
              hide-details
              dense
            />

            <v-autocomplete
              prepend-inner-icon="mdi-magnify"
              class="theme-custom-input input-search select-search crypto"
              v-model="filtersObj.currencyId"
              :items="cryptoCurrencyList.allItems"
              item-value="currencyId"
              item-text="iso"
              outlined
              :label="
                $t('panel.transactionPage.withdrawal.searchBoxesForm.crypto')
              "
              hide-details
              dense
              clearable
              :loading="cryptoCurrencyList.autocompleteListLoading"
              @focus="
                inputSearchCheck(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @keyup="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @paste="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @click:clear="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
            >
              <template v-slot:selection="{ item }">
                <div class="text-truncate">
                  {{ item.iso }} ({{ item.network }})
                </div>
              </template>
              <template v-slot:item="{ item }">
                {{ item.iso }} ({{ item.network }})
              </template>
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectIsoNetwork"
                  class="ms-4"
                  v-if="
                    !cryptoCurrencyList.moreItemsLoading &&
                      cryptoCurrencyList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="cryptoCurrencyList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>
          </div>

          <div
            class="d-flex flex-sm-wrap justify-space-around align-center align-content-center align-self-sm-end form-buttons"
          >
            <v-btn depressed color="primary" class="ma-3 order-1" type="submit">
              {{
                $t("panel.transactionPage.withdrawal.searchBoxesForm.submit")
              }}
            </v-btn>
            <v-btn outlined color="primary" @click="resetFilters">{{
              $t("panel.transactionPage.withdrawal.searchBoxesForm.reset")
            }}</v-btn>
          </div>
        </v-form>
      </div>

      <div class="mb-3 mx-1">
        <v-menu
          v-model="isMenuOpen"
          :close-on-content-click="false"
          z-index="10"
          content-class="filter-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" depressed outlined color="primary">
              <v-icon size="18" left>mdi-sort-bool-ascending-variant</v-icon>
              <span class="font-regular-12"> Table Setting </span>
            </v-btn>
          </template>
          <v-row class="mx-0" align="center">
            <v-col>
              <v-tooltip transition="slide-y-reverse-transition" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="d-inline-block">
                    <v-btn
                      :ripple="false"
                      depressed
                      icon
                      @click="resetFilteredHeaders"
                    >
                      <v-icon size="16">mdi-restart</v-icon>
                    </v-btn>
                  </div>
                </template>
                <span class="font-regular-12 darkest--text"> Reset </span>
              </v-tooltip>
            </v-col>
            <v-col cols="auto">
              <v-btn icon @click="isMenuOpen = false">
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>

          <v-list>
            <draggable v-model="defaultHeaders" @change="changeArrange">
              <template v-for="item in defaultHeaders">
                <v-list-item
                  v-if="item.colId !== 1 && item.colId !== 8"
                  :key="item.colId"
                >
                  <v-icon size="16" class="me-1"
                    >mdi-drag-horizontal-variant</v-icon
                  >
                  <v-checkbox
                    v-model="selectedFilter"
                    :ripple="false"
                    class="mt-0 pt-0"
                    hide-details
                    dense
                    :value="item.colId"
                    multiple
                    @change="changeArrange"
                  >
                    <template #label>
                      <v-list-item-title class="font-regular-12 black--text">{{
                        item.text
                      }}</v-list-item-title>
                    </template>
                  </v-checkbox>
                </v-list-item>
              </template>
            </draggable>
          </v-list>
        </v-menu>
      </div>

      <v-data-table
        fixed-header
        :headers="headers"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        hide-default-footer
        @page-count="pageCount = $event"
        :class="shortList"
      >
        <template v-slot:header.cryptoAmountString="{ header }">
          <span>{{ header.text }}</span>
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on, attrs }" class="d-inline">
              <v-icon small color="blue" v-bind="attrs" v-on="on" class="ms-1"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>{{ header.tooltip }}</span>
          </v-tooltip>
        </template>
        <template v-slot:header.localFiatCurrencyString="{ header }">
          <span>{{ header.text }}</span>
          <v-tooltip top color="primary">
            <template v-slot:activator="{ on, attrs }" class="d-inline">
              <v-icon small color="blue" v-bind="attrs" v-on="on" class="ms-1"
                >mdi-information-outline</v-icon
              >
            </template>
            <span>{{ header.tooltip }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.transactionStatus="{ item }">
          <v-chip
            class="transaction-status"
            label
            :color="$transactionStatusColor(item.transactionStatus).color"
            :text-color="
              $transactionStatusColor(item.transactionStatus).textColor
            "
          >
            {{ item.transactionStatus }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <router-link
            :to="{
              name: 'withdrawalDetails',
              params: { transactionId: item.transactionId }
            }"
          >
            {{ $t("panel.transactionPage.withdrawal.table.content.action") }}
          </router-link>
        </template>
        <template v-slot:item.crypto="{ item }">
          <div class="text-truncate" v-if="item.network">
            {{ item.iso }} ({{ item.network }})
          </div>
        </template>
        <template v-slot:item.transactionTime="{ item }">
          <div class="text-no-wrap">
            {{ item.transactionTime | $renderDate }}
          </div>
        </template>
        <template v-slot:item.username="{ item }">
          <router-link
            :to="{
              name: 'businessesList',
              query: { userId: item.userId }
            }"
            >{{ item.username }}</router-link
          >
        </template>
      </v-data-table>

      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        ></v-pagination>
      </div>
    </div>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import { transactionsService, currenciesService } from "@/services";
import renderDate from "@/mixins/renderDate";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import tableStatusItemColor from "@/mixins/tableStatusItemColor";
import autocompleteListLazyLoading from "@/mixins/autocompleteListLazyLoading";

export default {
  name: "withdrawal-list",
  components: {
    draggable
  },
  mixins: [
    renderDate,
    setFiltersQueries,
    tableStatusItemColor,
    autocompleteListLazyLoading
  ],
  data() {
    return {
      allCryptoCurrency: currenciesService.getAllCryptoCurrency,
      pageCount: 0,
      totalPages: 1,
      loading: false,
      shortList: false,
      filtersObj: {
        userId: "",
        transactionId: "",
        txHash: "",
        transactionStatuses: "",
        currencyId: "",
        page: 1,
        size: 10
      },
      statusItems: [],
      cryptoCurrencyList: {
        page: 1,
        size: 10,
        name: null,
        timeout: false,
        displayMoreItem: true,
        moreItemsLoading: false,
        autocompleteListLoading: false,
        allItems: []
      },
      dateDialog: false,
      date: [],
      tableData: [],
      isMenuOpen: false,
      selectedFilter: [1, 2, 3, 4, 5, 6, 7, 8],
      headers: [],
      defaultHeaders: [],
      withdraw_arrange: []
    };
  },
  watch: {
    withdraw_arrange: {
      deep: true,
      handler() {
        this.saveArrange();
        this.manipulateHeaders();
      }
    }
  },
  computed: {
    dateRangeText() {
      return this.date ? this.modifyDate() : "";
    }
  },
  async created() {
    this.setArrange();
    this.setHeaders();
    this.getTransactionsWithdrawalStatuses();
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
    this.callApiToSetFilters();
  },
  mounted() {
    this.setSelectedHeaders();
  },
  methods: {
    callApiToSetFilters() {
      if (this.filtersObj.userId) {
        this.getUserInfo();
      }
      if (this.filtersObj.currencyId) {
        this.getIsoInfo();
      } else {
        this.getCryptoCurrency();
      }
    },
    intersectIsoNetwork() {
      this.cryptoCurrencyList.page++;
      this.cryptoCurrencyList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.allCryptoCurrency,
        "cryptoCurrencyList",
        "iso",
        false
      );
    },
    setArrange() {
      if (localStorage.getItem("withdraw_arrange")) {
        try {
          this.withdraw_arrange = JSON.parse(
            localStorage.getItem("withdraw_arrange")
          );
        } catch (e) {
          localStorage.removeItem("withdraw_arrange");
        }
      }
    },
    getTransactionsWithdrawalStatuses() {
      transactionsService.getTransactionsWithdrawalStatuses().then(response => {
        this.statusItems = response.data.data;
      });
    },
    resetFilters() {
      for (let key in this.filtersObj) {
        this.filtersObj[key] = null;
      }
      this.filtersObj.page = 1;
      this.filtersObj.size = 10;
      this.date = [];
      this.filtersSubmission();
    },
    getCryptoCurrency() {
      const filters = {
        page: this.cryptoCurrencyList.page,
        size: this.cryptoCurrencyList.size
      };
      currenciesService.getAllCryptoCurrency(filters).then(response => {
        this.cryptoCurrencyList.allItems = response.data.data.content;
      });
    },
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    // setFiltersFromQuery() {
    //   Object.entries(this.$route.query).reduce((acc, [key, val]) => {
    //     if (key === "transactionTimeFrom" || key === "transactionTimeTo") {
    //       this.date.push(this.$renderDate(val));
    //     }
    //     if (
    //       key === "userId" ||
    //       key === "page" ||
    //       key === "size" ||
    //       key === "currencyId"
    //     ) {
    //       this.filtersObj[key] = +val;
    //     } else this.filtersObj[key] = val;
    //   }, {});
    // },
    // async updateQuery() {
    //   let queryParams = Object.entries(this.filtersObj).reduce(
    //     (acc, [key, val]) => {
    //       if (!val) return acc;
    //       return { ...acc, [key]: val };
    //     },
    //     {}
    //   );
    //   if (this.date.length) {
    //     const d = new Date(this.date[0]);
    //     if (this.date.length > 1) {
    //       const d0 = new Date(this.date[0]);
    //       const d1 = new Date(this.date[1]);
    //       queryParams.transactionTimeFrom = d0.getTime();
    //       queryParams.transactionTimeTo = d1.getTime();
    //     } else {
    //       queryParams.transactionTimeFrom = d.getTime();
    //     }
    //   }
    //   this.$router.replace({ query: { ...queryParams } }, () => {});
    //   await this.loadData(queryParams);
    // },
    async loadData(tableFilters) {
      this.loading = true;
      await transactionsService
        .getWithdrawalTransactions(tableFilters)
        .then(response => {
          this.tableData = response.data.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    modifyDate() {
      if (this.date[1]) {
        if (this.date[0] > this.date[1]) {
          const shift = this.date.pop();
          this.date.unshift(shift);
        }
      }
      return this.date.join(" ~ ");
    },
    setHeaders() {
      this.defaultHeaders = this.$t(
        "panel.transactionPage.withdrawal.table.header"
      );
      let headers = [];

      if (this.withdraw_arrange && this.withdraw_arrange.length) {
        this.withdraw_arrange.forEach(elem => {
          this.defaultHeaders.find(item => {
            if (item.colId === elem.id) headers.push(item);
          });
        });
        this.headers = [...headers];
      } else this.headers = [...this.defaultHeaders];
    },
    resetFilteredHeaders() {
      this.selectedFilter = [1, 2, 3, 4, 5, 6, 7, 8];
      this.changeArrange();
    },
    setSelectedHeaders() {
      if (this.withdraw_arrange && this.withdraw_arrange.length) {
        this.selectedFilter = [];
        this.withdraw_arrange.forEach(e => {
          if (e.enabled) this.selectedFilter.push(e.id);
        });
      }
    },
    changeArrange() {
      this.withdraw_arrange = [];
      this.defaultHeaders.forEach(elem => {
        if (this.selectedFilter.includes(elem.colId)) {
          this.withdraw_arrange.push({
            id: elem.colId,
            enabled: true
          });
        } else {
          this.withdraw_arrange.push({
            id: elem.colId,
            enabled: false
          });
        }
      });
      this.saveArrange();
    },
    manipulateHeaders() {
      if (this.withdraw_arrange && this.withdraw_arrange.length) {
        let headers = [];
        this.withdraw_arrange.forEach(elem => {
          this.defaultHeaders.find(item => {
            if (
              (item.colId === elem.id && elem.enabled) ||
              elem.colId === 1 ||
              elem.colId === 8
            )
              headers.push(item);
          });
        });
        this.headers = [...headers];
        // this.defaultHeaders.sort(
        //   (a, b) => this.headers.indexOf(a) - this.headers.indexOf(b)
        // );
      } else this.headers = [...this.defaultHeaders];
    },
    saveArrange() {
      const parsed = JSON.stringify(this.withdraw_arrange);
      localStorage.setItem("withdraw_arrange", parsed);
    }
  }
};
</script>

<style scoped lang="scss">
@import "List";
</style>
